import { fetchEndpointData } from '@utils/fetchEndpointData';

import type {
  CustomerPortalQuotationRequestListItem,
  CustomerPortalQuotationRequestResponse,
  CustomerPortalRequestQuoteBody,
  CustomerPortalRequestQuoteResponse,
} from './endpoints/CustomerPortalQuotationRequestsEndpoint.types';

export interface CustomerPortalQuotationRequestsFilters {
  search?: string;
}

export async function fetchCustomerPortalQuotationRequests(args: {
  customerId: number;
  cursor?: string;
  take?: number;
  filters?: CustomerPortalQuotationRequestsFilters;
}): Promise<CustomerPortalQuotationRequestListItem[]> {
  const searchParams = new URLSearchParams();
  searchParams.append('customerId', args.customerId.toString());
  if (args.cursor != null) {
    searchParams.append('id', args.cursor);
  }
  if (args.take != null) {
    searchParams.append('take', args.take.toString());
  }
  if (args.filters?.search) {
    searchParams.append('search', args.filters.search);
  }

  return fetchEndpointData<CustomerPortalQuotationRequestListItem[]>(
    `/api/customer-portal/quotation-requests?${searchParams.toString()}`,
    { method: 'GET' },
  );
}

export async function fetchCustomerPortalQuotationRequest(args: {
  id: string;
  customerId: number;
}): Promise<CustomerPortalQuotationRequestResponse> {
  const searchParams = new URLSearchParams();
  searchParams.append('customerId', args.customerId.toString());

  return fetchEndpointData<CustomerPortalQuotationRequestResponse>(
    `/api/customer-portal/quotation-requests/${args.id}?${searchParams.toString()}`,
    { method: 'GET' },
  );
}

export async function requestCustomerPortalQuote(
  data: CustomerPortalRequestQuoteBody,
): Promise<CustomerPortalRequestQuoteResponse> {
  return fetchEndpointData<CustomerPortalRequestQuoteResponse>('/api/customer-portal/quotation-requests', {
    method: 'POST',
    body: data,
  });
}
